import { WorkflowSelect } from './WorkflowSelect';

/**
 * Picks one workflow purely to scope `TriggerActionFields`' continue-task
 * target-step picker (`WorkflowStepSelect`) for a scheduled GitHub/GitLab
 * trigger profile (research.md D6).
 *
 * UI-only: a scheduled profile has no "watched workflow" of its own the way
 * a Spec 1 `workspace_task_change` profile does, so without this picker the
 * step selector would have to list every step across every workspace
 * workflow undifferentiated. Its value is never submitted — the backend's
 * `ContinueTaskAction` schema has no `target_workflow_id` field to send it
 * as (data-model.md) — a caller passes only the *resulting* `targetStepId`
 * onward, never this component's own `value`.
 *
 * Thin wrapper over `WorkflowSelect` rather than a separate implementation:
 * the two need identical published-workflow filtering and combobox
 * behavior, and only differ in what their value is *for* — this component
 * exists as its own name so a caller's intent ("this workflow only scopes a
 * step picker") is legible at the call site, not because the underlying
 * picker behavior differs.
 */
export function TargetWorkflowSelect({
  workspaceId,
  value,
  onChange,
  disabled,
}: {
  workspaceId: string;
  value: string | undefined;
  onChange: (workflowId: string) => void;
  disabled?: boolean;
}) {
  return (
    <WorkflowSelect
      workspaceId={workspaceId}
      value={value}
      onChange={onChange}
      disabled={disabled}
      aria-label="Target workflow (for step selection only)"
    />
  );
}
